import {
  ADD_REPORTING_INFO,
  UPDATE_FETCH_REPORTING_DATA_INPROGRESS,
  ADD_LOADBALANCE_LOG_INFO,
  UPDATE_LOADBALANCE_LOG_INPROGRESS,
  UPDATE_FETCH_QCLOGS_DATA_INPROGRESS,
  ADD_QC_LOG_INFO,
  ADD_REPORT_UPLOAD_LOG_INFO,
  UPDATE_FETCH_REPORT_UPLOAD_DATA_INPROGRESS,
} from '../../actions'

export const addReportingInfoReducer = (state = { fetchInProgress: false }, action) => {
  switch (action.type) {
    case ADD_REPORTING_INFO:
      return { ...state, ...action.payload }
    case UPDATE_FETCH_REPORTING_DATA_INPROGRESS:
      return { ...state, fetchInProgress: action.inProgress }
    default:
      return state
  }
}

export const addLoadBalanceLogInfoReducer = (state = { fetchInProgress: false }, action) => {
  switch (action.type) {
    case ADD_LOADBALANCE_LOG_INFO:
      return { ...state, ...action.payload }
    case UPDATE_LOADBALANCE_LOG_INPROGRESS:
      return { ...state, fetchInProgress: action.inProgress }
    default:
      return state
  }
}
export const addQCLogInfoReducer = (state = { fetchInProgress: false }, action) => {
  switch (action.type) {
    case ADD_QC_LOG_INFO:
      return { ...state, ...action.payload }
    case UPDATE_FETCH_QCLOGS_DATA_INPROGRESS:
      return { ...state, fetchInProgress: action.inProgress }
    default:
      return state
  }
}

export const addReportUploadReducer = (state = { fetchInProgress: false }, action) => {
  switch (action.type) {
    case ADD_REPORT_UPLOAD_LOG_INFO:
      return { ...state, ...action.payload }
    case UPDATE_FETCH_REPORT_UPLOAD_DATA_INPROGRESS:
      return { ...state, fetchInProgress: action.inProgress }
    default:
      return state
  }
}
